module.exports = __webpack_public_path__ + "img/tablet-VTA-VALORACION-AGENCIA02.406374f8.png";